import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import { ToastProvider } from '../hooks/useToast';
import { LucideIcon } from 'lucide-react';

interface LayoutProps {
  children: React.ReactNode;
  title?: string;
  icon?: LucideIcon;
  description?: string;
}

  export default function Layout({ children, title, icon: Icon, description }: LayoutProps) {
    const [sidebarOpen, setSidebarOpen] = useState(false);
	
    // On mount, open the sidebar by default for desktop widths (md+)
    useEffect(() => {
      if (typeof window !== 'undefined') {
        setSidebarOpen(window.innerWidth >= 768);
      }
    }, []);
	
    return (
      <ToastProvider>
        <div className="flex h-screen bg-gray-100">
          {/* Overlay para mobile */}
          {sidebarOpen && (
            <div
              className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
              onClick={() => setSidebarOpen(false)}
            ></div>
          )}
	
          {/* Sidebar - sempre visível em desktop, toggle em mobile */}
          <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
	
          {/* Main Content */}
          <div className="flex-1 flex flex-col overflow-hidden md:ml-56">
            {/* Mobile Header com Hamburger e Título/Ícone */}
            <div className="md:hidden bg-white border-b border-gray-200 px-4 py-4 flex items-center justify-between z-20">
              <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="inline-flex items-center justify-center p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition"
                aria-label="Toggle menu"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
              {Icon && title ? (
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 bg-blue-50 border border-blue-100 rounded-lg flex items-center justify-center">
                    <Icon className="w-4 h-4 text-blue-600" />
                  </div>
                  <h1 className="text-base font-bold text-gray-900">{title}</h1>
                </div>
              ) : (
                <h1 className="text-lg font-bold text-gray-900">FinanceApp</h1>
              )}
              <div className="w-10"></div>
            </div>
	
            {/* Content Area */}
            <div className="flex-1 overflow-y-auto">{children}</div>
          </div>
        </div>
      </ToastProvider>
    );
  }
